module.exports = __webpack_public_path__ + "img/magna-data-logo.36ebcafb.png";